var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var HubspotImportConfig_1;
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ImportOperation } from '../importTask';
import { ImportConfig, ImportConfigType } from './importConfig';
import { hubspotImportConfigSchemaValidation } from '../../validations.generated';
export const hubspotImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:HubspotImportConfig',
    type: 'object',
    properties: {
        startDate: { type: 'string', format: 'date-time' }
    },
    required: ['startDate']
};
let HubspotImportConfig = HubspotImportConfig_1 = class HubspotImportConfig extends ImportConfig {
    constructor(startDate, columnsToUpdate) {
        super(ImportConfigType.Hubspot, columnsToUpdate);
        this.startDate = startDate;
        JSON.validate(this, HubspotImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [ImportOperation.Overwrite];
    }
    get needsDiscovery() {
        return true;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], HubspotImportConfig.prototype, "startDate", void 0);
HubspotImportConfig = HubspotImportConfig_1 = __decorate([
    JsonSchemaV2(hubspotImportConfigSchema, hubspotImportConfigSchemaValidation),
    JsonDiscriminatorValue(ImportConfigType.Hubspot)
], HubspotImportConfig);
export { HubspotImportConfig };
//# sourceMappingURL=hubspotImportConfig.js.map